import styled from '@emotion/styled'
import type { Theme } from '@yuno/design-system-web'

export const RowItem = styled.div`
  margin-bottom: 30px;
`

export const Title = styled.span<{ children: string; theme?: Theme }>`
  color: ${({ theme }) => theme.palette.neutral.black};
  font-weight: ${({ theme }) => theme.typography.small.bold.fontWeight};
  margin-bottom: 16px;
  font-size: ${({ theme }) => theme.typography.small.bold.fontSize};
  font-family: ${({ theme }) => theme.typography.small.bold.fontFamily};
`

export const TitleTip = styled.span<{ children: string; theme?: Theme }>`
  color: ${({ theme }) => theme.palette.neutral.black};
  font-weight: ${({ theme }) => theme.typography.small.bold.fontWeight};
  margin-bottom: 8px;
  font-size: ${({ theme }) => theme.typography.base.bold.fontSize};
  font-family: ${({ theme }) => theme.typography.small.bold.fontFamily};
`

export const PageTitle = styled.span<{ children: string; theme?: Theme }>`
  color: ${({ theme }) => theme.palette.neutral.black};
  font-weight: ${({ theme }) => theme.typography.xl.regular.fontWeight};
  font-size: ${({ theme }) => theme.typography.xl.regular.fontSize};
  font-family: ${({ theme }) => theme.typography.xl.regular.fontFamily};
`

export const CardTitle = styled.span<{ children: string; theme?: Theme }>`
  color: ${({ theme }) => theme.palette.neutral.black};
  font-weight: ${({ theme }) => theme.typography.xl.regular.fontWeight};
  font-size: ${({ theme }) => theme.typography.l.regular.fontSize};
  font-family: ${({ theme }) => theme.typography.xl.regular.fontFamily};
  margin-bottom: 8px;
`

export const Content = styled.span<{ theme?: Theme }>`
  color: ${({ theme }) => theme.palette.neutral.black};
  padding-right: 50px;
  font-weight: ${({ theme }) => theme.typography.small.regular.fontWeight};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  font-family: ${({ theme }) => theme.typography.small.regular.fontFamily};
  padding-bottom: 8px;

  & span {
    color: ${({ theme }) => theme.palette.primary[1]};
  }
`
